// Accessibility helpers.
//
// keyActivate(handler) returns an onKeyDown handler that invokes `handler`
// when the user presses Enter or Space, mirroring an element's onClick so that
// keyboard users can activate click-only elements (SonarQube S1082 /
// jsx-a11y/click-events-have-key-events). Mouse behaviour is unchanged.
export const keyActivate = (handler) => (e) => {
  if (e.key === "Enter" || e.key === " ") {
    e.preventDefault();
    handler(e);
  }
};
